import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import Footer from '../footer/footerbkp';
import Header from '../header/newheader';
import close from '../assets/closegrey.png'

class ClusterDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mission: '',
            proj: false,
            pub: false,
            theses: false,
            events: false
        }
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    list() {
        Axios(BASE + 'jsonapi/node/research_cluster', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    mission: data.data.data
                })

            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.setState({
                data1: null
            })
            let link = nextProps.match.params.id
            let links=link.replace(/-/g,' ')
            console.log('id', links)
            this.loadDetails(link)

        }
    }
    loadDetails(id) {
        Axios(`${BASE}jsonapi/node/research_cluster/${id}?include=field_cis_program,field_cluster_research_projects,field_events,field_publications,field_publications.field_author,field_publications.field_journal,field_publications.field_books,field_relevant_centers,field_student_theses`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                console.log('details',data.data)
                this.setState({
                    data1: data.data
                })
                var elmnt1 = document.querySelectorAll('.center_accordion ul');
                var elmnt2 = document.querySelectorAll('.center_accordion h2');

                elmnt1[elmnt1.length - 1].classList.add("bord-bottom")


                document.querySelectorAll('.center_accordion h2').forEach(function (el, ind) {
                    // if(ind===elmnt1.length-1){
                    //     el.classList.add("bord-bot");
                    // }
                    el.onclick = function () {
                        if (el.classList.contains("active")) {
                            el.classList.remove("active");
                            el.nextElementSibling.style.display = 'none';
                            el.nextElementSibling.classList.remove("active");
                            document.querySelectorAll('.center_accordion h2').forEach(function (el) {
                                el.classList.remove("active");
                            });
                        }
                        else {
                            document.querySelectorAll('.center_accordion ul').forEach(function (el) {
                                el.style.display = 'none';
                            });
                            document.querySelectorAll('.center_accordion h2').forEach(function (el) {
                                el.classList.remove("active");
                            });
                            el.classList.add("active");
                            el.nextElementSibling.style.display = 'block';
                            el.nextElementSibling.classList.add("active");

                        }
                    };
                });
                if (this.props.match.params.section) {
                    var elmnt = document.querySelectorAll(`#${this.props.match.params.section} h2`);

                    elmnt[0].scrollIntoView();
                    elmnt[0].classList.add("active");
                    elmnt[0].nextElementSibling.style.display = 'block';
                    elmnt[0].nextElementSibling.classList.add("active");
                }

            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillMount() {
        this.list()
        this.topFunction();
        let link = this.props.match.params.id
        let links=link.replace(/-/g,' ')
        console.log('ids', links)
        this.loadDetails(link)
        //ResrchDiviison
    }
    checkThesis(eventarray, id) {
        let arr = eventarray.map(a => a.id);
        var a = arr.indexOf(id);
        if (a !== -1)
            return false
        else
            return true
    }
    checkPub(eventarray, id) {
        let arr = eventarray.map(a => a.id);
        var a = arr.indexOf(id);
        if (a !== -1)
            return false
        else
            return true
    }
    render() {
        return (
            <div id="cluster_popup" className="cluster_full_details">
                <Header />
                <div className=" container">
                    <div className="">
                        <div className='formrea clusterpage yourwork sub_work'>
                            {this.state.data1 ?
                                <div className="listing">
                                    <div className="page-title">
                                        <div className="title-wrapper">
                                            <div className="">
                                               {this.state.data1.data?  <h1 className="page-header">{this.state.data1.data.attributes.title}</h1>:""}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.data1 ?
                                        <div className="clusterdesc">
                                            {ReactHtmlParser(this.state.data1.data.attributes.body.value)}
                                        </div>
                                        : ''}
                                    {/* <div className="readmore">Read more &rarr;</div> */}

                                    {this.state.data1.data.attributes.field_detailed_information ?
                                        <div id="center_accordion">
                                            <h3 className="sub_heading">DETAILED INFO</h3>
                                            <div className="center_accordion">
                                                {ReactHtmlParser(this.state.data1.data.attributes.field_detailed_information.value)}
                                            </div>
                                        </div>
                                        : null}





                                    <div className="center_accordion accordion_main">
                                        {this.state.data1 && this.state.data1.data.relationships.field_cluster_research_projects.data.length !== 0 ?

                                            <div id="projects">
                                                <h2 onClick={() => {
                                                    this.setState({
                                                        proj: !this.state.proj
                                                    })
                                                }} className="sub_heading">CLUSTER PROJECTS</h2>
                                                <ul>
                                                    {this.state.data1.included.filter(item => item.type === "node--projects").map((inst, index) => {
                                                        return (
                                                            <div className="clusterlist">
                                                                <div className="title">
                                                                    <span className="field-content">
                                                                        <Link to={"/projects/" + inst.attributes.drupal_internal__nid}>
                                                                            {inst.attributes.title}
                                                                        </Link>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            : null}

                                        {this.state.data1 && this.state.data1.data.relationships.field_publications.data.length !== 0 ?
                                            <div id="publication">
                                                <h2 onClick={() => {
                                                    this.setState({
                                                        pub: !this.state.pub
                                                    })
                                                }} className="sub_heading">PUBLICATIONS</h2>
                                                {this.state.data1 && this.state.data1.data.relationships.field_publications.data.length !== 0 ?
                                                    <ul>
                                                        {this.state.data1.included.filter(item => item.type === "node--submit_for_work").map((inst, index) => {
                                                            if (this.checkPub(this.state.data1.data.relationships.field_publications.data, inst.id))
                                                                return (
                                                                    <div className="clusterlist">
                                                                        <div className="title">
                                                                            <span className="field-content">
                                                                                <Link to={"/publication/" + inst.attributes.drupal_internal__nid}>
                                                                                    {inst.attributes.title}
                                                                                </Link>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                        })}
                                                    </ul>
                                                    : null}
                                            </div>
                                            : ''}
                                        {this.state.data1 && this.state.data1.data.relationships.field_student_theses.data.length !== 0 ?
                                            <div id="theses">
                                                <h2 onClick={() => {
                                                    this.setState({
                                                        theses: !this.state.theses
                                                    })
                                                }} className="sub_heading">THESES</h2>
                                                {this.state.data1 && this.state.data1.data.relationships.field_student_theses.data.length !== 0 ?
                                                    <ul>
                                                        {this.state.data1.included.filter(item => item.type === "node--submit_for_work").map((inst, index) => {
                                                            if (this.checkThesis(this.state.data1.data.relationships.field_student_theses.data, inst.id))
                                                                return (
                                                                    <div className="clusterlist">
                                                                        <div className="title">
                                                                            <span className="field-content">
                                                                                <Link to={"/publication/" + inst.attributes.drupal_internal__nid}>
                                                                                    {inst.attributes.title}
                                                                                </Link>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                        })}
                                                    </ul>
                                                    : null}
                                            </div>
                                            : ''}

                                        {this.state.data1 && this.state.data1.data.relationships.field_events.data.length !== 0 ?
                                            <div id="events">
                                                <h2 onClick={() => {
                                                    this.setState({
                                                        events: !this.state.events
                                                    })
                                                }} className="sub_heading">EVENTS</h2>
                                                {this.state.data1 && this.state.data1.data.relationships.field_events.data.length !== 0 ?
                                                    <ul>
                                                        {this.state.data1.included.filter(item => item.type === "node--events").map((inst, index) => {
                                                            return (
                                                                <div className="clusterlist">
                                                                    <div className="title">
                                                                        <span className="field-content">
                                                                            <Link to={"/event_desc/" + inst.attributes.drupal_internal__nid}>
                                                                                {inst.attributes.title}
                                                                            </Link>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </ul>
                                                    : null}
                                            </div>
                                            : ''}
                                    </div>                                    
                                    {this.state.data1.data.attributes.field_research_interest ?
                                        <h3 className="sub_heading">RELEVANT RESEARCH INTERESTS</h3> : ''}
                                    {this.state.data1.data.attributes.field_research_interest ?
                                        <div className="center_accordion">
                                            {ReactHtmlParser(this.state.data1.data.attributes.field_research_interest.value)}
                                        </div>
                                        : null}


                                </div> : <List />}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        )
    }
}

export default ClusterDetails;
